import { IgDialog } from "@intelligems/ig-theme/IgDialog";

import { ControlsPanel, type ControlsPanelProps } from "./ControlsPanel";

/**
 * The code's Dependencies and Secrets, opened from the settings button at the
 * end of the view switch — for a workspace whose settings do not sit in a
 * column beside the editor (`controlsPanel.presentation: "dialog"`).
 */
export const CodeSettingsDialog = ({
  open,
  onClose,
  ...panel
}: Omit<ControlsPanelProps, "presentation" | "sections" | "aiChat"> & {
  open: boolean;
  onClose: () => void;
}) => (
  <IgDialog
    showDialog={open}
    title="Code settings"
    handleClose={onClose}
    handleNoClick={onClose}
    hideActions
    showCloseIcon
    minWidth="480px"
    maxWidth="sm"
    dialogContentWidth="100%"
    content={
      <ControlsPanel
        {...panel}
        aiChat={null}
        presentation="sections"
        sections={["dependencies", "secrets"]}
      />
    }
  />
);
